<template>
  <div class="common_template" v-show="dilgShow">
    <div class="dialog">
      <div class="msk"></div>
      <div class="content_dialog">
        <i class="dialog_x" @click="closePop()"></i>
        <div class="dialog_form" v-show="!successText">
          <div class="fz18">申请成为易知鸟合伙人</div>
          <div class="tag textAcenter">{{ errorText }}</div>
          <div class="form-control">
            <label for="name">机构或公司名称</label>
            <input
              id="name"
              type="text"
              autocomplete="off"
              placeholder="请输入您的机构或公司名称"
              v-model="param.visitorShopName"
              required
            />
          </div>
          <div class="form-control">
            <label for="name">姓名</label>
            <input
              id="name"
              type="text"
              autocomplete="off"
              placeholder="请输入您的姓名"
              v-model="param.name"
              required
            />
          </div>
          <div class="form-control">
            <label for="phone">手机号</label>
            <input
              id="phone"
              type="text"
              autocomplete="off"
              placeholder="请输入您的联系方式"
              v-model="param.phone"
              maxlength="11"
              required
            />
          </div>

          <div class="submitBtn" @click="submitBtn()">
            提交
          </div>
        </div>
        <!--成功显示-->
        <div class="dialog_success lf" v-show="successText">
          <div class="dianzan"></div>
          <div class="title_success">信息提交成功</div>
          <div class="title_info">{{ successText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      dilgShow: false,
      param: {
        name: "",
        phone: "",
        visitorShopName: ""
      },
      errorText: "",
      loading: false,
      successText: ""
    };
  },
  methods: {
    openJoinDialog: function() {
      var this_ = this;
      this_.dilgShow = true;
      this_.param = {
        name: "",
        phone: ""
      };
      this_.successText = "";
      this_.errorText = "";
      this_.loading = false;
    },
    closePop: function() {
      this.dilgShow = false;
    },
    submitBtn: function() {
      if (!this.param.visitorShopName) {
        this.errorText = "请输入机构或公司名称";
        return;
      }
      if (!this.param.name) {
        this.errorText = "请输入您的姓名";
        return;
      }
      if (!this.checkValidate()) {
        this.errorText = "请输入正确联系方式";
        return;
      }
      var data = {
        visitorName: this.param.name,
        visitorPhone: this.param.phone,
        visitorShopName: this.param.visitorShopName,
        visitorSource: "8",
        codeStatus: "0"
      };
      this.loading = true;
      var this_ = this;
      $.ajax({
        url: this_.CONFIG.URL + "/api/admin/visitor/add",
        type: "post",
        data: JSON.stringify(data),
        async: false,
        contentType: "application/json;charset=UTF-8",
        success: function(data) {
          this_.$nextTick(() => {
            this_.loading = false;
            if (data.status == "200") {
              this_.successText = data.message;
            } else {
              this_.errorText = data.message;
            }
          });
        },
        error: function(data) {
          this_.$nextTick(() => {
            this_.loading = false;
            this_.errorText = "网络异常,请稍后再试";
          });
        }
      });
    },
    checkValidate: function() {
      if (!/^1\d{10}$/.test(this.param.phone)) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped lang="less">
/*以下是公用弹框等样式*/
.common_template .dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 19931221;
}
.common_template .dialog .msk {
  width: 100%;
  height: 100%;
  background-color: #333333;
  opacity: 0.8;
}
.common_template .dialog .content_dialog {
  width: 463px;
  height: 518px;
  border-radius: 16px;
  padding: 45px 56px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -231px;
  margin-top: -223px;
}
.common_template .dialog .dialog_x {
  width: 27px;
  height: 27px;
  position: absolute;
  border-radius: 50%;
  top: -40px;
  right: 0;
  background: url(/static/img/tankuang/x.png) no-repeat #ccd5e7;
  background-position: center center;
  background-size: 50% 50%;
  transition: all 0.5s;
  transform: rotate(0deg);
  cursor: pointer;
}
.common_template .dialog .dialog_x:hover {
  transform: rotate(360deg);
}
.common_template .dialog .dialog_success {
  padding: 0 10%;
}
.common_template .dialog .tag {
  color: #fa7074;
  height: 24px;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog_form {
  .fz18 {
    font-weight: 500;
  }
  .form-control {
    margin-bottom: 30px;
    label {
      font-size: 16px;
      color: #222222;
      display: block;
      text-align: left;
      margin-bottom: 10px;
    }
    input {
      width: 350px;
      height: 36px;
      border-radius: 2px;
      border: 1px solid #bbbbbb;
      text-align: left;
      padding: 7px 18px;
    }
  }
  .submitBtn {
    width: 350px;
    height: 50px;
    font-size: 18px;
    line-height: 50px;
    color: #fff;
    background: #fa7074;
    border-radius: 4px;
    text-align: center;
    border: none;
    box-shadow: 2px 0px 8px rgba(16, 16, 18, 0.21);
    margin: 62px auto 0;
    cursor: pointer;
  }
}
.title_success {
  color: #00a5f8;
  font-size: 24px;
  font-weight: bold;
  margin-top: 22px;
}
.title_info {
  color: #999999;
  font-size: 16px;
  font-weight: bold;
  margin-top: 22px;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog_join.vue